import { Select } from 'antd'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'

const { Option } = Select

const languageDictionary = {
  es: 'Español',
  en: 'English',
  fr: 'Français'
}

const LanguageSelector = ({
  availableLanguages = []
}) => {
  const { region, lang, filename } = useParams()

  const options = availableLanguages.map((lang, idx) => (
    <Option value={lang} key={idx}>{languageDictionary[lang]}</Option>
  ))

  const onChange = lang => {
    setTimeout(() => {
      window.location = `/${region}/${lang}/${filename}`
    }, 300)
  }

  return (
    <div className='RegionSelector'>
      <Select size='large' onChange={onChange} value={lang}>
        {options}
      </Select>
    </div>
  )
}

export default LanguageSelector
